const StaticBuilderModalEnum = {
  OPEN_STATIC_SECOND_ACTION_MODAL: 'OPEN_STATIC_SECOND_ACTION_MODAL',
  CLOSE_STATIC_SECOND_ACTION_MODAL: 'CLOSE_STATIC_SECOND_ACTION_MODAL',
};

export default StaticBuilderModalEnum;



// WEBPACK FOOTER //
// ./src-react/StaticBuilderModals/StaticBuilderModalConstants.jsx